import { Route, Navigate, useParams } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import ErrorPage from '../modules/error/ErrorPage';

const ReqProjectTypeManagement = lazy(() => import('../modules/reqProjectType/management'));
const ReqProjectTypeResponse = lazy(() => import('../modules/reqProjectType/response'));
const ResponseDetailPage = lazy(
  () => import('../modules/reqProjectType/response/ResponseDetailPage')
);
const ReqProjectTypeAnalytics = lazy(() => import('../modules/reqProjectType/analytics'));
const CreateQuestionnaireProjectTypePage = lazy(
  () => import('../modules/reqProjectType/management/CreateQuestionnaireProjectTypePage')
);
const EditQuestionnaireProjectTypePage = lazy(
  () => import('../modules/reqProjectType/management/EditQuestionnaireProjectTypePage')
);
const QuestionBuilderPage = lazy(
  () => import('../modules/reqProjectType/management/QuestionBuilderPage')
);
const QuestionnaireFlowPreviewPage = lazy(
  () => import('../modules/reqProjectType/management/QuestionnaireFlowPreviewPage')
);
const ClientViewPage = lazy(() => import('../modules/reqProjectType/clientView'));
const ClientQuestionnaireFlowPage = lazy(
  () => import('../modules/reqProjectType/clientView/ClientQuestionnaireFlowPage')
);
const CreateProjectTypePage = lazy(() => import('../modules/admin/projectType/CreateProjectTypePage'));
const EditProjectTypePage = lazy(() => import('../modules/admin/projectType/EditProjectTypePage'));
const ProjectTypeDetails = lazy(() => import('../modules/admin/projectType/ProjectTypeDetails'));

const LegacyProjectTypeDetailsRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/req-project-type/management/boq/${id}`} replace />;
};

const LegacyProjectTypeEditRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/req-project-type/management/boq/edit/${id}`} replace />;
};

const ReqProjectTypeRoutes = (
  <>
    <Route
      path="/req-project-type"
      element={<Navigate to="/req-project-type/analytics" replace />}
    />
    <Route
      path="/req-project-type/management"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <ReqProjectTypeManagement />
        </Suspense>
      }
      errorElement={<ErrorPage />}
    />
    <Route
      path="/req-project-type/response"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <ReqProjectTypeResponse />
        </Suspense>
      }
      errorElement={<ErrorPage />}
    />
    <Route
      path="/req-project-type/response/:typeId/:responseId"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <ResponseDetailPage />
        </Suspense>
      }
      errorElement={<ErrorPage />}
    />
    <Route
      path="/req-project-type/analytics"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <ReqProjectTypeAnalytics />
        </Suspense>
      }
      errorElement={<ErrorPage />}
    />
    <Route
      path="/req-project-type/client-view"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <ClientViewPage />
        </Suspense>
      }
      errorElement={<ErrorPage />}
    />
    <Route
      path="/req-project-type/client-view/:clientId"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <ClientViewPage />
        </Suspense>
      }
      errorElement={<ErrorPage />}
    />
    <Route
      path="/req-project-type/client-view/:clientId/:typeId"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <ClientQuestionnaireFlowPage />
        </Suspense>
      }
      errorElement={<ErrorPage />}
    />
    <Route
      path="/req-project-type/management/questionnaire/create"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <CreateQuestionnaireProjectTypePage />
        </Suspense>
      }
      errorElement={<ErrorPage />}
    />
    <Route
      path="/req-project-type/management/questionnaire/edit/:id"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <EditQuestionnaireProjectTypePage />
        </Suspense>
      }
      errorElement={<ErrorPage />}
    />
    <Route
      path="/req-project-type/management/questionnaire/:id/questions"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <QuestionBuilderPage />
        </Suspense>
      }
      errorElement={<ErrorPage />}
    />
    <Route
      path="/req-project-type/management/questionnaire/:id/preview"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <QuestionnaireFlowPreviewPage />
        </Suspense>
      }
      errorElement={<ErrorPage />}
    />
    <Route
      path="/req-project-type/management/boq/create"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <CreateProjectTypePage />
        </Suspense>
      }
      errorElement={<ErrorPage />}
    />
    <Route
      path="/req-project-type/management/boq/edit/:id"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <EditProjectTypePage />
        </Suspense>
      }
      errorElement={<ErrorPage />}
    />
    <Route
      path="/req-project-type/management/boq/:id"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <ProjectTypeDetails />
        </Suspense>
      }
      errorElement={<ErrorPage />}
    />
    {/* Legacy redirects */}
    <Route
      path="/admin/project-types/create"
      element={<Navigate to="/req-project-type/management/boq/create" replace />}
    />
    <Route
      path="/admin/project-types/edit/:id"
      element={<LegacyProjectTypeEditRedirect />}
    />
    <Route
      path="/admin/project-types/:id"
      element={<LegacyProjectTypeDetailsRedirect />}
    />
    <Route
      path="/settings/project-types"
      element={<Navigate to="/req-project-type/management?tab=boq" replace />}
    />
  </>
);

export default ReqProjectTypeRoutes;
